import { render, staticRenderFns } from "./gameDisposition.vue?vue&type=template&id=5c965c75&"
import script from "./gameDisposition.vue?vue&type=script&lang=js&"
export * from "./gameDisposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c965c75')) {
      api.createRecord('5c965c75', component.options)
    } else {
      api.reload('5c965c75', component.options)
    }
    module.hot.accept("./gameDisposition.vue?vue&type=template&id=5c965c75&", function () {
      api.rerender('5c965c75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/gameDisposition.vue"
export default component.exports